<template>
    <div class="login-out">
        <div class="head-right">
            <a-dropdown>
                <span class="user-data">
                    <span style="">消耗量</span>
                </span>
                <a-menu slot="overlay" class="user-data-select">
                    <a-menu-item style="font-size:12px;width:230px">
                        <div>
                            <span style="color:rgba(18, 18, 18, 1)">公司总消耗/公司总额度：</span>
                            <span style="color:rgba(34, 215, 187, 1)">{{consumptionData.companyTotalUsageAmount}} / {{consumptionData.companyTotalQuota==-1?'0':consumptionData.companyTotalQuota}}</span>
                        </div>
                        <div>
                            <span style="color:rgba(18, 18, 18, 1)">公司月消耗/公司月额度：</span>
                            <span style="color:rgba(34, 215, 187, 1)">{{consumptionData.companyMonthlyUsageAmount}} / {{consumptionData.companyMonthlyQuota==-1?'0':consumptionData.companyMonthlyQuota}}</span>
                        </div>
                        <div>
                            <span style="color:rgba(18, 18, 18, 1)">用户月消耗/用户月额度：</span>
                            <span style="color:rgba(34, 215, 187, 1)">{{consumptionData.userMonthlyUsageAmount}} / {{consumptionData.userMonthlyQuota==-1?'0':consumptionData.userMonthlyQuota}}</span>
                        </div>
                    </a-menu-item>
                </a-menu>
            </a-dropdown>
            <a-dropdown class="account">
                <span class="avatar">
                    <span style="">{{userInfoData.name}}</span>
                    <a-icon style="float:right;margin-top:3px;" type="caret-down" />
                </span>
                <a-menu slot="overlay" style="width:280px;cursor:default">
                    <a-menu-item style="text-align:center;height:42px;line-height:35px;">
                        <a href="javascript:;" @click="goBasicInfo">
                            <span style="color:rgba(18, 18, 18, 1);font-size:14px;">基本信息</span>
                        </a>
                    </a-menu-item>
                    <a-menu-divider/>
                    <a-menu-item style="text-align:center;height:42px;line-height:35px;">
                        <a href="javascript:;" @click="loginOut">
                            <span style="color:rgba(18, 18, 18, 1);font-size:14px;">退出登录</span>
                        </a>
                    </a-menu-item>
                </a-menu>
            </a-dropdown>
        </div>
    </div>
</template>

<script>
export default {
    props:[],
    data(){
        return{
            supportData: '',
            basicInfo: '',
            balanceData: '',
            consumptionData: '',
            userInfoData: ''
        }
    },
    methods: {
        loginOut() {
            this.$router.push("/Login")
            sessionStorage.removeItem('menuKey')
            sessionStorage.removeItem('token')
        },
        goBasicInfo() {
            this.$router.push("/PersonalInfo")
        },
        queryUseInfo() {
            this.axios(
                {
                    method:'get',
                    url:'/api/externalInterface/queryDosage', 
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.consumptionData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryUserInfo(params) {
            this.userInfoData = params
        },
    },
    mounted: function() {
        this.queryUseInfo()
    }
}
</script>
<style scoped lang="less">
    .login-out{
        display: inline-block;
        float: right;
        width: 100%;
        padding-top: 14px;
        .head-right{
            float: right;
            .user-data{
                margin-right: 48px;
                cursor: pointer;
            }
            .account{
                margin-top: 4px;
                display: inline-block;
                cursor: pointer;
                .avatar{
                    margin-top: 10px;
                    cursor: pointer;
                }
            }
        }
    }
</style>
